export default "__VITE_ASSET__9bd6bf1c__"